<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算执行行</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.period">
                <el-select filterable v-model="period" placeholder="请选择期间" clearable size="mini">
                    <el-option v-for="item in periodOptionAll" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addRow" icon="el-icon-plus" v-if="postList.addBtn">新增预算执行行</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_execution"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'reim_person_name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'mk_report_code'">
                                <el-link v-if="mk_show" type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row.mk_report_id }}
                                </el-link>
                                <span v-else> {{ scope.row.mk_report_id }} </span>
                            </div>
                            <div v-else-if="item.prop == 'budget_item_name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row.budget_item_name }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'partner_name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row.partner_name }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'budget_execution_report'">
                                <span>
                                    {{ scope.row.budget_execution_report.approval_status_label }}
                                    <!-- {{ scope.row.budget_execution_report.status_label }} （{{
                                        scope.row.budget_execution_report.approval_status_label
                                    }}） {{ scope.row.budget_execution_report.completion_date }} -->
                                </span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" align="center" fixed="right" width="85" v-if="dataShow">
                    <template slot-scope="scope" style="height: 100%">
                        <!-- <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="updateRow(scope.row)"></i>
                        </el-tooltip> -->
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amendRow(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
            <!-- 新增预算执行行 -->
            <el-dialog
                :close-on-click-modal="false"
                v-dialogDrag
                :title="title"
                :visible.sync="dialogFormVisible"
                width="700px"
                :modal="false"
                :append-to-body="true"
            >
                <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
                    <div class="for_details" v-for="(item, index) in ruleForm.executions" :key="index">
                        <el-form-item
                            label="预算项目："
                            :prop="'executions.' + index + '.budget_item_rid'"
                            :rules="{
                                required: true,
                                message: '预算项目不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                        >
                            <el-select
                                v-model="item.budget_item_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入预算项目名称搜索"
                                :remote-method="remoteBudgetMethod"
                                :loading="budgetLoading"
                                size="mini"
                                clearable
                                value-key="rid"
                                @change="budgetItemChange(item, index)"
                                style="width: 100%"
                                :disabled="budgetDisabled"
                            >
                                <el-option v-for="item in projectOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="报销人："
                            :prop="'executions.' + index + '.reim_person_rid'"
                            :rules="{
                                required: true,
                                message: '报销人不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                        >
                            <el-select
                                v-model="item.reim_person_rid"
                                filterable
                                reserve-keyword
                                placeholder="请选择报销人"
                                size="mini"
                                clearable
                                style="width: 100%"
                            >
                                <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="冲销历史："
                            :prop="'executions.' + index + '.is_write_off_history'"
                            :rules="{
                                required: true,
                                message: '冲销历史不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                            v-if="mk_report_type == '对公'"
                        >
                            <el-select
                                v-model="item.is_write_off_history"
                                filterable
                                reserve-keyword
                                placeholder="请选择是否冲销历史"
                                size="mini"
                                @change="historyChange(item, index)"
                                style="width: 100%"
                            >
                                <el-option v-for="item in historyTypeOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="业务类型："
                            :prop="'executions.' + index + '.corp_type'"
                            :rules="{
                                required: true,
                                message: '业务类型不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                            v-if="mk_report_type == '对公'"
                        >
                            <el-select
                                v-model="item.corp_type"
                                filterable
                                reserve-keyword
                                placeholder="请选择业务类型"
                                size="mini"
                                :disabled="item.corpDisabled"
                                @change="corpChange(item, index)"
                                style="width: 100%"
                            >
                                <el-option v-for="item in corpOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="支付金额："
                            :prop="'executions.' + index + '.amount'"
                            :rules="{
                                required: true,
                                message: '支付金额不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                            v-if="item.amountShow"
                        >
                            <el-input
                                v-model="item.amount"
                                autocomplete="off"
                                placeholder="请输入支付金额"
                                @keyup.native="item.amount = oninput(item.amount)"
                                clearable
                                size="mini"
                                :disabled="item.amountDisabled"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="发票金额："
                            :prop="'executions.' + index + '.invoice_amount'"
                            :rules="{
                                required: true,
                                message: '发票金额不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                            v-if="item.invoiceAmountShow"
                        >
                            <el-input
                                v-model="item.invoice_amount"
                                autocomplete="off"
                                placeholder="请输入发票金额"
                                @keyup.native="item.invoice_amount = oninput(item.invoice_amount)"
                                clearable
                                size="mini"
                                :disabled="item.invoiceAmountDisabled"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="税金："
                            :prop="'executions.' + index + '.tax_amount'"
                            :rules="{
                                required: true,
                                message: '税金不能为空',
                                trigger: 'blur'
                            }"
                            class="row_width"
                            v-if="item.taxAmountShow"
                        >
                            <el-input
                                v-model="item.tax_amount"
                                autocomplete="off"
                                placeholder="请输入税金"
                                @keyup.native="item.tax_amount = oninput(item.tax_amount)"
                                clearable
                                size="mini"
                                :disabled="item.taxAmountDisabled"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="备注：" :prop="'executions.' + index + '.remark'" class="row_width">
                            <el-input v-model="item.remark" autocomplete="off" placeholder="请输入备注" clearable size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="费用类型：" :prop="'executions.' + index + '.fee_type_rid'" class="row_width">
                            <el-select
                                style="width: 100%"
                                clearable
                                v-model="item.fee_type_rid"
                                filterable
                                reserve-keyword
                                placeholder="请选择费用类型"
                                size="mini"
                            >
                                <el-option v-for="item in feeTypeList" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 每行历史业务 -->
                        <el-dialog
                            title="历史业务"
                            :visible.sync="dialogdataVisible"
                            width="1000px"
                            v-dialogDrag
                            :before-close="dataCancel"
                            :modal="false"
                        >
                            <el-input v-model="search_key" placeholder="请输入单据编号或单据事由" @keyup.enter.native="getHistory">
                                <i slot="suffix" class="el-input__icon el-icon-search search_class" @click="getHistory"></i>
                            </el-input>
                            <el-empty description="无历史业务" v-if="historyList.length == 0"></el-empty>
                            <el-checkbox-group v-model="item.checkList" class="history" @change="checkChange">
                                <div v-for="item in historyList" :key="item.mk_report_id" class="history_list">
                                    <div class="header_title">
                                        <span>{{ item.name }}</span>
                                        <span>{{ item.mk_report_id }}</span>
                                    </div>
                                    <el-checkbox
                                        v-for="(ite, inde) in item.budget_executions"
                                        :key="inde"
                                        :label="ite"
                                        :disabled="ite.disabled"
                                        class="item_content"
                                        @change="checkboxChange(ite)"
                                    >
                                        <div class="tag_text">
                                            <span>{{ ite.mk_report_line_id }}</span>
                                            <el-tag v-if="ite.corp_type == 2" type="success" effect="dark">预付</el-tag>
                                            <el-tag v-else type="warning" effect="dark">到票</el-tag>
                                        </div>
                                        <div class="right_content" v-if="ite.corp_type == 2">
                                            <div class="t_div">
                                                <span>总金额</span>
                                                <span>￥{{ ite.amount }}</span>
                                            </div>
                                            <div class="b_div">
                                                <span>尚未收回</span>
                                                <span>￥{{ ite.pending_amount }}</span>
                                            </div>
                                        </div>
                                        <div class="right_content" v-else>
                                            <div class="t_div">
                                                <span>总金额</span>
                                                <span>￥{{ ite.invoice_amount }}</span>
                                            </div>
                                            <div class="b_div">
                                                <span>尚未支付</span>
                                                <span>￥{{ ite.pending_amount }}</span>
                                            </div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dataCancel">取 消</el-button>
                                <el-button type="primary" @click="dataSubmit">确 定</el-button>
                            </div>
                        </el-dialog>
                        <!-- 每行冲销历史 -->
                        <el-dialog
                            title="冲销历史"
                            :visible.sync="item.dialogLineVisible"
                            width="1000px"
                            v-dialogDrag
                            :before-close="dataLineCancel"
                            :modal="false"
                        >
                            <el-input v-model="search_key_write" placeholder="请输入单据编号或单据事由" @keyup.enter.native="getWriteOffs">
                                <i slot="suffix" class="el-input__icon el-icon-search search_class" @click="getWriteOffs"></i>
                            </el-input>
                            <el-empty description="无冲销历史" v-if="historyList.length == 0"></el-empty>
                            <el-checkbox-group v-model="item.checkList" class="history" :max="1">
                                <div v-for="item in historyList" :key="item.mk_report_id" class="history_list">
                                    <div class="header_title">
                                        <span>{{ item.name }}</span>
                                        <span>{{ item.mk_report_id }}</span>
                                    </div>
                                    <el-checkbox
                                        v-for="(ite, inde) in item.budget_executions"
                                        :key="inde"
                                        :label="ite"
                                        :disabled="ite.disabled"
                                        class="item_content"
                                    >
                                        <div class="tag_text">
                                            <span>{{ ite.mk_report_line_id }}</span>
                                            <el-tag v-if="ite.corp_type == 2" type="success" effect="dark">预付</el-tag>
                                            <el-tag v-else-if="ite.corp_type == 3" type="warning" effect="dark">到票</el-tag>
                                            <el-tag v-else-if="ite.corp_type == 4" type="warning" effect="dark">历史业务</el-tag>
                                        </div>
                                        <div class="right_content" v-if="ite.corp_type == 2">
                                            <div class="t_div">
                                                <span>支付金额</span>
                                                <span>￥{{ ite.amount }}</span>
                                            </div>
                                            <div class="b_div">
                                                <span>可冲销金额</span>
                                                <span>￥{{ ite.pending_amount }}</span>
                                            </div>
                                        </div>
                                        <div class="right_content" v-else-if="ite.corp_type == 3">
                                            <div class="t_div">
                                                <span>发票金额</span>
                                                <span>￥{{ ite.invoice_amount }}</span>
                                            </div>
                                            <div class="b_div">
                                                <span>可冲销发票金额</span>
                                                <span>￥{{ ite.pending_amount }}</span>
                                            </div>
                                        </div>
                                        <div class="right_content" v-else-if="ite.corp_type == 4">
                                            <div class="t_div" v-if="ite.invoice_amount > 0">
                                                <span>发票金额</span>
                                                <span>￥{{ ite.invoice_amount }}</span>
                                            </div>
                                            <div class="t_div" v-else>
                                                <span>支付金额</span>
                                                <span>￥{{ ite.amount }}</span>
                                            </div>
                                            <div class="b_div" v-if="ite.invoice_amount > 0">
                                                <span>可冲销发票金额</span>
                                                <span>￥{{ ite.invoice_amount }}</span>
                                            </div>

                                            <div class="b_div" v-else>
                                                <span>可冲销金额</span>
                                                <span>￥{{ ite.amount }}</span>
                                            </div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dataLineCancel">取 消</el-button>
                                <el-button type="primary" @click="dataLineSubmit">确 定</el-button>
                            </div>
                        </el-dialog>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancle">取 消</el-button>
                    <el-button type="primary" @click="onData('ruleForm')" :loading="okLoading">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 费用详情 -->
        <el-dialog
            title="费用详情"
            :modal="false"
            :visible.sync="dialogCheckedVisible"
            width="900px"
            v-dialogDrag
            :before-close="dataHistoryCancel"
        >
            <el-form ref="form" :model="dataCheckedList" label-width="100px" class="detail_from" :rules="rulesDetails">
                <el-form-item label="支付金额" prop="amount" v-if="amountItemShow">
                    <el-input placeholder="请输入支付金额" v-model="dataCheckedList.amount" :disabled="amountDisabled"></el-input>
                </el-form-item>
                <el-form-item label="发票金额" prop="invoice_amount" v-if="invoiceAmountItemShow">
                    <el-input
                        placeholder="请输入发票金额"
                        v-model="dataCheckedList.invoice_amount"
                        :disabled="invoiceAmountDisabled"
                    ></el-input>
                </el-form-item>
                <el-form-item label="税金" prop="tax_amount" v-if="taxAmountItemShow">
                    <el-input placeholder="请输入税金" v-model="dataCheckedList.tax_amount"></el-input>
                </el-form-item>
                <el-form-item label="备注" class="reamrk_item">
                    <el-input placeholder="请输入备注" type="textarea" show-word-limit v-model="dataCheckedList.remark"></el-input>
                </el-form-item>
                <div class="checked_">
                    <el-form-item
                        v-for="(item, index) in dataCheckedList.checkList"
                        :key="index"
                        class="checked_list"
                        :prop="'checkList.' + index + '.newAmount'"
                        :rules="{
                            required: newAmountShow,
                            message: '金额不能为空',
                            trigger: 'blur'
                        }"
                    >
                        <div class="checked_title">
                            <span>{{ item.mk_report_line_id }}</span>
                            <span>{{ item.rid }}</span>
                        </div>
                        <div class="checked_content">
                            <div class="tag_text">
                                <span>{{ item.mk_report_line_id }}</span>
                                <el-tag v-if="item.corp_type == 2" type="success" effect="dark">预付</el-tag>
                                <el-tag v-else-if="item.corp_type == 3" type="warning" effect="dark">到票</el-tag>
                                <el-tag v-else-if="item.corp_type == 4" type="warning" effect="dark">历史业务</el-tag>
                            </div>
                            <div class="right_content" v-if="item.corp_type == 2">
                                <div class="t_div">
                                    <span>支付金额</span>
                                    <span>￥{{ item.amount }}</span>
                                </div>
                                <div class="b_div">
                                    <span>可冲销金额</span>
                                    <span>￥{{ item.pending_amount }}</span>
                                </div>
                                <div class="amount_div">
                                    <span>冲销金额</span>
                                    <span>
                                        <el-input
                                            size="mini"
                                            :max="item.pending_amount"
                                            @change="newAmountChange2"
                                            v-model="item.newAmount"
                                        ></el-input
                                    ></span>
                                </div>
                            </div>
                            <div class="right_content" v-else-if="item.corp_type == 3">
                                <div class="t_div">
                                    <span>发票金额</span>
                                    <span>￥{{ item.invoice_amount }}</span>
                                </div>
                                <div class="b_div">
                                    <span>可冲销发票金额</span>
                                    <span>￥{{ item.pending_amount }}</span>
                                </div>
                                <div class="amount_div" v-if="newAmountShow">
                                    <span>冲销发票金额</span>
                                    <span>
                                        <el-input
                                            size="mini"
                                            :max="item.pending_amount"
                                            @change="newAmountChange3"
                                            v-model="item.newAmount"
                                        ></el-input
                                    ></span>
                                </div>
                            </div>
                            <div class="right_content" v-else-if="item.corp_type == 4">
                                <div class="t_div" v-if="item.invoice_amount > 0">
                                    <span>发票金额</span>
                                    <span>￥{{ item.invoice_amount }}</span>
                                </div>
                                <div class="t_div" v-else>
                                    <span>支付金额</span>
                                    <span>￥{{ item.amount }}</span>
                                </div>
                                <div class="b_div" v-if="item.invoice_amount > 0">
                                    <span>可冲销发票金额</span>
                                    <span>￥{{ item.invoice_amount }}</span>
                                </div>
                                <div class="t_div" v-else>
                                    <span>可冲销金额</span>
                                    <span>￥{{ item.amount }}</span>
                                </div>
                                <div class="amount_div">
                                    <span v-if="item.invoice_amount > 0">冲销发票金额</span>
                                    <span v-else>冲销金额</span>
                                    <span> <el-input size="mini" v-model="item.newAmount" disabled></el-input></span>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dataHistoryCancel">取 消</el-button>
                <el-button type="primary" @click="submitData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'budgetExecutionComponent',
    data() {
        return {
            budgetDisabled: false,
            newAmountShow: false,
            amountItemShow: false,
            amountDisabled: false,
            invoiceAmountDisabled: false,
            invoiceAmountItemShow: false,
            taxAmountItemShow: false,
            rulesDetails: {
                amount: [{ required: true, message: '请输入支付金额', trigger: 'blur' }],
                invoice_amount: [{ required: true, message: '请输入发票金额', trigger: 'blur' }],
                tax_amount: [{ required: true, message: '请输入税金', trigger: 'blur' }]
            },
            dialogCheckedVisible: false,
            search_key: '',
            search_key_write: '',
            draggable: {
                data_name: 'budget_execution'
            },
            mk_show: true,
            historyList: [],
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            period: '',
            periodOptionAll: [],
            budget_item_rid: '',
            okLoading: false,
            idRow: '',
            title: '',
            titleType: 1,
            budget_execution_report_rid: '',
            relation_mk_report_id: '',
            reim_person_rid: '',
            mk_report_type: '',
            supplier_rid: '',
            new_budget_item_name: '',
            new_budget_item_rid: '',
            postList1: {},
            dataShow: false,
            dialogFormVisible: false,
            //基本信息内表单验证
            ruleForm: {
                executions: []
            },
            dialogdataVisible: false,
            budgetLoading: false,
            projectOptions: [],
            feeTypeList: [],
            historyTypeOptions: [
                {
                    value: '1',
                    name: '是'
                },
                {
                    value: '2',
                    name: '否'
                }
            ],
            corpOptions: [],
            principalOptions: [],
            dataCheckedList: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.budget_item_rid) {
                        this.budget_item_rid = newValue.params.budget_item_rid;
                        this.mk_show = true;
                    }
                    if (newValue.params.budget_execution_report_rid) {
                        this.budget_execution_report_rid = newValue.params.budget_execution_report_rid;
                        this.mk_report_type = newValue.params.mk_report_type;
                        this.supplier_rid = newValue.params.supplier_rid;
                        this.mk_show = false;
                    }
                    if (newValue.params.relation_mk_report_id) {
                        this.mk_show = true;
                        this.relation_mk_report_id = newValue.params.relation_mk_report_id;
                        this.dataShow = false;
                    } else {
                        this.dataShow = true;
                    }
                    if (newValue.params.reim_person_rid) {
                        this.reim_person_rid = newValue.params.reim_person_rid;
                    }
                }
                this.getList(0); //获取列表
            }
        },
        deep: true
    },
    mounted() {
        this.ruleForm.executions = this.getEexecutionTemplate();

        if (this.postList.params) {
            this.row = 10;
        }
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.getDropdownPeriodAll();
            this.getPrincipal();
            this.getCorp();
            this.getFeeTypes();
            if (this.mk_report_type == '对公') {
                this.invoiceAmountShow = false;
                this.amountShow = false;
                this.taxAmountShow = false;
            } else {
                this.amountShow = true;
                this.taxAmountShow = true;
                this.invoiceAmountShow = false;
            }
            this.getList(0); //获取列表
        });
    },
    methods: {
        getEexecutionTemplate() {
            return [
                {
                    invoice_amount: '',
                    tax_amount: '',
                    budget_item_rid: this.new_budget_item_rid || '',
                    budget_item_name: this.new_budget_item_name || '',
                    amount: '',
                    remark: '',
                    reim_person_rid: '',
                    corp_type: '',
                    fee_type_rid: '',
                    is_write_off_history: '2',
                    history_type: '',
                    amountShow: true,
                    invoiceAmountShow: false,
                    taxAmountShow: true,
                    checkList: [],
                    dialogLineVisible: false
                }
            ];
        },
        //取消新增弹窗按钮
        cancle() {
            this.dialogFormVisible = false;
            this.ruleForm.executions = this.getEexecutionTemplate();
        },
        //业务类型
        getCorp() {
            let params = {};
            this.$api
                .dropdownCorpType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.corpOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //用户下拉
        getPrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.principalOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //提交数据
        onData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.okLoading = true;
                    if (this.titleType == 1) {
                        if (this.mk_report_type == '对公') {
                            this.checkData(); //处理数据
                        }
                        this.insertDetail(); //新增
                    } else {
                        this.updateDetail(); //修改
                    }
                } else {
                    return false;
                }
            });
        },
        //新增
        insertDetail() {
            if (this.mk_report_type == '对公') {
                var params = {};
                params = this.newExecutions[0];
                params.corp_type = JSON.stringify(params.corp_type);
                params.rid = this.budget_execution_report_rid;
            } else {
                var params = {
                    budget_item_rid: this.ruleForm.executions[0].budget_item_rid,
                    amount: this.ruleForm.executions[0].amount,
                    invoice_amount: this.ruleForm.executions[0].amount,
                    tax_amount: this.ruleForm.executions[0].tax_amount,
                    reim_person_rid: this.ruleForm.executions[0].reim_person_rid,
                    fee_type_rid: this.ruleForm.executions[0].fee_type_rid,
                    rid: this.budget_execution_report_rid,
                    remark: this.ruleForm.executions[0].remark
                };
            }
            this.$api
                .budgetExecutionReportInsertDetail(params)
                .then((res) => {
                    this.okLoading = false;
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.getList(0); //获取列表
                        location.reload();
                    }
                })
                .catch((error) => {
                    this.okLoading = false;
                });
        },
        //修改
        updateDetail() {
            let params = {
                budget_item_rid: this.ruleForm.budget_item_rid,
                amount: this.ruleForm.amount,
                reim_person_rid: this.ruleForm.reim_person_rid,
                type: this.ruleForm.type,
                budget_execution_rid: this.idRow
            };
            this.$api
                .budgetExecutionReportUpdateDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.okLoading = false;
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.getList(0); //获取列表
                    }
                })
                .catch((error) => {
                    this.okLoading = false;
                });
        },
        //修改行
        updateRow(row) {
            this.title = '修改预算执行行';
            this.dialogFormVisible = true;
            this.titleType = 2;
            this.idRow = row.rid;
            this.ruleForm = {
                budget_item_rid: row.budget_item_rid,
                budget_item_name: row.budget_item_name,
                amount: row.amount,
                reim_person_rid: row.reim_person_rid,
                type: row.type
            };
        },
        //删除预算执行行列表单行
        amendRow(id) {
            var params = {
                budget_execution_rid: id.toString()
            };
            let messages = '此操作将删除此行数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetExecutionReportDeleteDetail(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getList(0); //获取列表
                                    location.reload();
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //费用类型下拉
        getFeeTypes() {
            let params = {};
            this.$api
                .dropdownFeeTypes(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.feeTypeList = res.data;
                    }
                })
                .catch((error) => {});
        },
        //新增预算执行行
        addRow() {
            this.dialogFormVisible = true;
            this.titleType = 1;
            this.title = '新增预算执行行';
            this.ruleForm.executions = this.getEexecutionTemplate();
        },
        //分配期间全部下拉
        getDropdownPeriodAll() {
            let params = {
                all: 1
            };
            this.$api
                .dropdownPeriod(params)
                .then((res) => {
                    if (res.code == 0) {
                        if (this.postList.budgetItemPeriod) {
                            res.data = res.data.map((item) => {
                                item.name = this.postList.budgetItemPeriod + item.name.substr(2, 2);
                                item.value = this.postList.budgetItemPeriod + item.value.substr(2, 2);
                                return item;
                            });
                        }

                        this.periodOptionAll = res.data;
                    }
                })
                .catch((error) => {});
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_execution', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_execution;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'mk_report_code' && row.budget_execution_report_rid && row.mk_report_id) {
                this.$router.push({
                    path: '/budgetReportDetails',
                    query: {
                        id: row.budget_execution_report_rid,
                        mk_report_id: row.mk_report_id
                    }
                });
            } else if (prop == 'reim_person_name' && row.reim_person_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.reim_person_rid
                    }
                });
            } else if (prop == 'budget_item_name' && row.budget_item_rid) {
                this.$router.push({
                    path: '/budgetItemDetails',
                    query: {
                        id: row.budget_item_rid
                    }
                });
            } else if (prop == 'partner_name' && row.partner_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var num = type_data;
            var params = {
                page: this.page,
                row: this.row,
                period: this.period,
                budget_item_rid: this.budget_item_rid,
                budget_execution_report_rid: this.budget_execution_report_rid,
                relation_mk_report_id: this.relation_mk_report_id,
                reim_person_rid: this.reim_person_rid,
                sort: [this.data_name, this.sort],
                is_export: num
            };
            if (num == 0) {
                this.loading = true;
                this.$api
                    .budgetExecutionLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            if (this.mk_report_type == '对公') {
                                this.ruleForm.executions[0].budget_item_name = res.data.data[0].budget_item_name;
                                this.ruleForm.executions[0].budget_item_rid = res.data.data[0].budget_item_rid;
                                this.new_budget_item_name = res.data.data[0].budget_item_name;
                                this.new_budget_item_rid = res.data.data[0].budget_item_rid;
                                this.budgetDisabled = true;
                            } else {
                                this.budgetDisabled = false;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .budgetExecutionDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.period = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            this.getList(0);
            this.selectedColData();
        },
        //项目下拉
        remoteBudgetMethod(query) {
            if (query !== '') {
                this.budgetLoading = true;
                let params = {
                    key: query
                };
                this.$api
                    .searchBudgetItems(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.budgetLoading = false;
                                this.projectOptions = res.data;
                            }, 200);
                        } else {
                            this.projectOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.budgetLoading = false;
                this.projectOptions = [];
            }
        },
        //是否冲销历史
        historyChange(item, index) {
            this.ruleForm.executions[index].checkList = [];
            this.ruleForm.executions[index].amount = '';
            this.ruleForm.executions[index].invoice_amount = '';
            this.ruleForm.executions[index].tax_amount = '';
            this.ruleForm.executions[index].remark = '';
            this.ruleForm.executions[index].amountDisabled = false;
            this.ruleForm.executions[index].invoiceAmountDisabled = false;
            this.ruleForm.executions[index].taxAmountDisabled = false;
            if (item.is_write_off_history == '1') {
                this.ruleForm.executions[index].corp_type = '';
                if (this.ruleForm.executions[index].budget_item_rid) {
                    this.ruleForm.executions[index].corpDisabled = true;
                    this.ruleForm.executions[0].dialogLineVisible = true;
                    this.getWriteOffs();
                } else {
                    this.$message({
                        message: '请先选择预算项目',
                        type: 'warning'
                    });
                    this.ruleForm.executions[index].is_write_off_history = '2';
                    this.ruleForm.executions[index].corp_type = '';
                    this.ruleForm.executions[index].corpDisabled = false;
                }
            } else {
                this.ruleForm.executions[index].corp_type = 4;
                this.ruleForm.executions[index].corpDisabled = false;
            }
        },
        //业务类型变化
        corpChange(item, index) {
            this.ruleForm.executions[index].checkList = [];
            this.ruleForm.executions[index].amount = '';
            this.ruleForm.executions[index].invoice_amount = '';
            this.ruleForm.executions[index].tax_amount = '';
            this.ruleForm.executions[index].remark = '';
            if (item.corp_type == 2) {
                this.ruleForm.executions[index].amountShow = true;
                this.ruleForm.executions[index].invoiceAmountShow = false;
                this.ruleForm.executions[index].taxAmountShow = false;
            } else if (item.corp_type == 3) {
                this.ruleForm.executions[index].amountShow = true;
                this.ruleForm.executions[index].invoiceAmountShow = true;
                this.ruleForm.executions[index].taxAmountShow = true;
            } else if (item.corp_type == 4) {
                if (this.ruleForm.executions[index].budget_item_rid) {
                    // this.ruleForm.executions[0].dialogdataVisible = true;
                    this.dialogdataVisible = true;
                    this.getHistory();
                } else {
                    this.$message({
                        message: '请先选择预算项目',
                        type: 'warning'
                    });
                    this.ruleForm.executions[index].corp_type = '';
                }
            } else {
                this.ruleForm.executions[index].amountShow = false;
                this.ruleForm.executions[index].invoiceAmountShow = false;
                this.ruleForm.executions[index].taxAmountShow = false;
            }
        },
        //正则验证
        oninput(value) {
            //可以输入正负号，小数点，保留两位
            let str = value;
            if (isNaN(str) && !/^-$/.test(str)) {
                str = '';
            }
            if (!/^[+-]?\d*\.{0,1}\d{0,1}$/.test(str)) {
                str = str.replace(/\.\d{2,}$/, str.substr(str.indexOf('.'), 3));
            }
            return str;
        },
        //历史业务窗口取消
        dataCancel() {
            this.ruleForm.executions[0].checkList = [];
            this.dialogdataVisible = false;
            this.ruleForm.executions[0].corp_type = '';
        },
        //请求历史业务下拉接口
        getHistory() {
            let params = {
                // supplier_rid: 'ACCT0000000001',
                supplier_rid: this.supplier_rid,
                budget_item_rid: this.ruleForm.executions[0].budget_item_rid,
                search_key: this.search_key
            };
            this.$api
                .budgetExecutionReportHistories(params)
                .then((res) => {
                    if (res.code == 0) {
                        var arr = res.data;
                        for (let index = 0; index < arr.length; index++) {
                            for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                                arr[index].budget_executions[inde].disabled = false;
                            }
                        }
                        this.dataList = arr;
                        this.historyList = this.dataList;
                    } else {
                        this.historyList = [];
                    }
                })
                .catch((error) => {});
        },
        //当选中数据发生变化时
        checkChange(value) {
            var arr = this.historyList;
            if (value.length == 0) {
                for (let index = 0; index < arr.length; index++) {
                    for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                        arr[index].budget_executions[inde].disabled = false;
                    }
                }
            }
        },
        //选中单条数据发生变化
        checkboxChange(ite) {
            if (ite.corp_type == 3) {
                let arr = this.historyList;
                for (let index = 0; index < arr.length; index++) {
                    for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                        arr[index].budget_executions[inde].disabled = true;
                        if (ite.rid == arr[index].budget_executions[inde].rid) {
                            arr[index].budget_executions[inde].disabled = false;
                        }
                    }
                }
            } else {
                let arr = this.historyList;
                for (let index = 0; index < arr.length; index++) {
                    for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                        if (arr[index].budget_executions[inde].corp_type == 3) {
                            arr[index].budget_executions[inde].disabled = true;
                        }
                    }
                }
            }
        },
        //历史业务确定按钮
        dataSubmit() {
            if (this.ruleForm.executions[0].checkList.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '还未选择数据'
                });
            } else {
                this.amountDisabled = false;
                this.invoiceAmountDisabled = false;
                if (this.ruleForm.executions[0].checkList[0].corp_type == 2) {
                    // this.ruleForm.executions[0].dialogdataVisible = false;
                    this.dialogdataVisible = false;
                    this.dataCheckedList = this.ruleForm.executions[0]; //赋值弹确认框
                    this.ruleForm.executions[0].amountShow = true;
                    this.ruleForm.executions[0].invoiceAmountShow = true;
                    this.ruleForm.executions[0].taxAmountShow = true;
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = true;
                    this.taxAmountItemShow = true;
                    this.dialogCheckedVisible = true;
                } else {
                    this.newAmountShow = false; //业务类型为历史业务的到票时隐藏
                    // this.ruleForm.executions[0].dialogdataVisible = false;
                    this.dialogdataVisible = false;
                    this.ruleForm.executions[0].amountShow = true;
                    this.ruleForm.executions[0].invoiceAmountShow = false;
                    this.ruleForm.executions[0].taxAmountShow = false;
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = false;
                    this.taxAmountItemShow = false;
                    this.dataCheckedList = this.ruleForm.executions[0]; //赋值弹确认框
                    this.dialogCheckedVisible = true;
                }
            }
        },
        //冲销历史行下拉 取消
        dataLineCancel() {
            this.ruleForm.executions[0].checkList = [];
            this.ruleForm.executions[0].dialogLineVisible = false;
            this.ruleForm.executions[0].corp_type = '';
            this.ruleForm.executions[0].corpDisabled = false;
            this.ruleForm.executions[0].is_write_off_history = '2';
            this.ruleForm.executions[0].amountDisabled = false;
            this.ruleForm.executions[0].invoiceAmountDisabled = false;
            this.ruleForm.executions[0].taxAmountDisabled = false;
        },
        //冲销历史下拉
        getWriteOffs() {
            this.ruleForm.executions[0].checkList = [];
            let params = {
                budget_item_rid: this.ruleForm.executions[0].budget_item_rid,
                // supplier_rid: 'ACCT0000000001',
                supplier_rid: this.supplier_rid,
                search_key: this.search_key_write
            };
            this.$api
                .toBeWrittenOffLists(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.historyList = res.data;
                    } else {
                        this.historyList = [];
                    }
                })
                .catch((error) => {});
        },
        //冲销历史确定按钮
        dataLineSubmit() {
            if (this.ruleForm.executions[0].checkList.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '还未选择数据'
                });
            } else {
                this.ruleForm.executions[0].amountDisabled = true;
                this.ruleForm.executions[0].invoiceAmountDisabled = true;
                this.ruleForm.executions[0].taxAmountDisabled = true;
                if (this.ruleForm.executions[0].checkList[0].corp_type == 2) {
                    //预付
                    this.ruleForm.executions[0].dialogLineVisible = false;
                    this.dataCheckedList = this.ruleForm.executions[0]; //赋值弹确认框
                    this.ruleForm.executions[0].amountShow = true;
                    this.ruleForm.executions[0].corp_type = 2;
                    this.ruleForm.executions[0].invoiceAmountShow = false;
                    this.ruleForm.executions[0].taxAmountShow = false;
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = false;
                    this.taxAmountItemShow = false;
                    this.dialogCheckedVisible = true;
                    this.amountDisabled = true;
                    this.invoiceAmountDisabled = true;
                    if (this.ruleForm.executions[0].checkList[0].newAmount) {
                        this.dataCheckedList.amount = -Math.abs(this.ruleForm.executions[0].checkList[0].newAmount);
                    }
                } else if (this.ruleForm.executions[0].checkList[0].corp_type == 3) {
                    this.ruleForm.executions[0].corp_type = 3;
                    this.ruleForm.executions[0].dialogLineVisible = false;
                    this.ruleForm.executions[0].amountShow = false;
                    this.ruleForm.executions[0].invoiceAmountShow = true;
                    this.ruleForm.executions[0].taxAmountShow = false;
                    this.amountItemShow = false;
                    this.newAmountShow = true; //业务类型为冲销历史的到票时显示
                    this.invoiceAmountItemShow = true;
                    this.taxAmountItemShow = false;
                    this.dataCheckedList = this.ruleForm.executions[0]; //赋值弹确认框
                    this.dialogCheckedVisible = true;
                    this.amountDisabled = true;
                    this.invoiceAmountDisabled = true;
                    if (this.ruleForm.executions[0].checkList[0].newAmount) {
                        this.dataCheckedList.invoice_amount = -Math.abs(this.ruleForm.executions[0].checkList[0].newAmount);
                    }
                } else if (this.ruleForm.executions[0].checkList[0].corp_type == 4) {
                    this.ruleForm.executions[0].corp_type = 4;
                    this.ruleForm.executions[0].dialogLineVisible = false;
                    this.dataCheckedList = this.ruleForm.executions[0]; //赋值弹确认框
                    this.dialogCheckedVisible = true;
                    this.ruleForm.executions[0].new_invoice_amount = this.ruleForm.executions[0].checkList[0].invoice_amount;
                    if (this.ruleForm.executions[0].checkList[0].invoice_amount > 0) {
                        this.amountDisabled = false;
                        this.invoiceAmountDisabled = true;
                        this.ruleForm.executions[0].amountShow = false;
                        this.ruleForm.executions[0].invoiceAmountShow = true;
                        this.ruleForm.executions[0].taxAmountShow = false;
                        this.amountItemShow = false;
                        this.invoiceAmountItemShow = true;
                        this.taxAmountItemShow = false;
                        this.dataCheckedList.invoice_amount = -this.ruleForm.executions[0].checkList[0].invoice_amount;
                        this.ruleForm.executions[0].checkList[0].newAmount = -this.ruleForm.executions[0].checkList[0].invoice_amount;
                    } else {
                        this.amountDisabled = true;
                        this.invoiceAmountDisabled = false;
                        this.ruleForm.executions[0].amountShow = true;
                        this.ruleForm.executions[0].invoiceAmountShow = false;
                        this.ruleForm.executions[0].taxAmountShow = false;
                        this.amountItemShow = true;
                        this.invoiceAmountItemShow = false;
                        this.taxAmountItemShow = false;
                        this.dataCheckedList.amount = -this.ruleForm.executions[0].checkList[0].amount;
                        this.ruleForm.executions[0].checkList[0].newAmount = -this.ruleForm.executions[0].checkList[0].amount;
                    }
                }
            }
        },
        //费用详情 取消
        dataHistoryCancel() {
            this.dataCheckedList.amount = '';
            this.dataCheckedList.invoice_amount = '';
            this.dataCheckedList.tax_amount = '';
            this.dataCheckedList.remark = '';
            this.ruleForm.executions[0].checkList = [];
            this.ruleForm.executions[0].corp_type = '';
            this.ruleForm.executions[0].amount = '';
            this.ruleForm.executions[0].invoice_amount = '';
            this.ruleForm.executions[0].is_write_off_history = '2';
            this.ruleForm.executions[0].corpDisabled = false;
            this.ruleForm.executions[0].amountDisabled = false;
            this.ruleForm.executions[0].invoiceAmountDisabled = false;
            this.ruleForm.executions[0].taxAmountDisabled = false;
            this.ruleForm.executions[0].tax_amount = '';
            this.ruleForm.executions[0].remark = '';
            this.dialogCheckedVisible = false;
        },
        //费用详情下 预付单和 到票支付单联动
        newAmountChange2(value) {
            if (this.ruleForm.executions[0].is_write_off_history == '1') {
                this.dataCheckedList.amount = -Math.abs(value);
                this.ruleForm.executions[0].checkList[0].newAmount = -Math.abs(value);
            }
        },
        newAmountChange3(value) {
            if (this.ruleForm.executions[0].is_write_off_history == '1') {
                this.dataCheckedList.invoice_amount = -Math.abs(value);
                this.ruleForm.executions[0].checkList[0].newAmount = -Math.abs(value);
            }
        },
        //费用详情确定按钮
        submitData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.dialogCheckedVisible = false;
                } else {
                    return false;
                }
            });
        },
        //处理数据
        checkData() {
            var arr = this.ruleForm.executions;
            var arr1 = [];
            for (let index = 0; index < arr.length; index++) {
                if (arr[index].is_write_off_history == '2') {
                    //不冲销历史
                    if (arr[index].corp_type == 2) {
                        //业务类型为预付
                        arr1.push({
                            amount: arr[index].amount,
                            invoice_amount: 0,
                            tax_amount: 0,
                            remark: arr[index].remark,
                            budget_item_rid: arr[index].budget_item_rid,
                            reim_person_rid: arr[index].reim_person_rid,
                            fee_type_rid: arr[index].fee_type_rid,
                            corp_type: arr[index].corp_type
                        });
                    } else if (arr[index].corp_type == 3) {
                        //业务类型为到票
                        arr1.push({
                            amount: arr[index].amount,
                            invoice_amount: arr[index].invoice_amount,
                            tax_amount: arr[index].tax_amount,
                            remark: arr[index].remark,
                            budget_item_rid: arr[index].budget_item_rid,
                            reim_person_rid: arr[index].reim_person_rid,
                            fee_type_rid: arr[index].fee_type_rid,
                            corp_type: arr[index].corp_type
                        });
                    } else if (arr[index].corp_type == 4) {
                        //业务类型历史预付
                        if (arr[index].checkList[0].corp_type == 2) {
                            let history_data = [];
                            for (let inde = 0; inde < arr[index].checkList.length; inde++) {
                                history_data.push({
                                    rid: arr[index].checkList[inde].rid,
                                    amount: arr[index].checkList[inde].newAmount
                                });
                            }
                            arr1.push({
                                amount: arr[index].amount,
                                invoice_amount: arr[index].invoice_amount,
                                tax_amount: arr[index].tax_amount,
                                remark: arr[index].remark,
                                history_type: 1,
                                history_data: history_data,
                                budget_item_rid: arr[index].budget_item_rid,
                                reim_person_rid: arr[index].reim_person_rid,
                                fee_type_rid: arr[index].fee_type_rid,
                                corp_type: arr[index].corp_type
                            });
                        } //业务类型历史到票
                        else if (arr[index].checkList[0].corp_type == 3) {
                            arr1.push({
                                amount: arr[index].amount,
                                invoice_amount: 0,
                                tax_amount: 0,
                                history_type: 2,
                                remark: arr[index].remark,
                                history_rid: arr[index].checkList[0].rid,
                                budget_item_rid: arr[index].budget_item_rid,
                                reim_person_rid: arr[index].reim_person_rid,
                                fee_type_rid: arr[index].fee_type_rid,
                                corp_type: arr[index].corp_type
                            });
                        }
                    }
                } else {
                    //冲销历史
                    if (arr[index].corp_type == 2) {
                        arr1.push({
                            amount: arr[index].amount,
                            invoice_amount: 0,
                            tax_amount: 0,
                            remark: arr[index].remark,
                            write_off_rid: arr[index].checkList[0].rid,
                            budget_item_rid: arr[index].budget_item_rid,
                            reim_person_rid: arr[index].reim_person_rid,
                            fee_type_rid: arr[index].fee_type_rid,
                            corp_type: arr[index].corp_type
                        });
                    } else if (arr[index].corp_type == 3) {
                        arr1.push({
                            invoice_amount: arr[index].invoice_amount,
                            tax_amount: 0,
                            amount: 0,
                            remark: arr[index].remark,
                            write_off_rid: arr[index].checkList[0].rid,
                            budget_item_rid: arr[index].budget_item_rid,
                            reim_person_rid: arr[index].reim_person_rid,
                            fee_type_rid: arr[index].fee_type_rid,
                            corp_type: arr[index].corp_type
                        });
                    } else if (arr[index].corp_type == 4) {
                        if (arr[index].new_invoice_amount > 0) {
                            arr1.push({
                                invoice_amount: arr[index].invoice_amount,
                                tax_amount: 0,
                                amount: 0,
                                remark: arr[index].remark,
                                write_off_rid: arr[index].checkList[0].rid,
                                budget_item_rid: arr[index].budget_item_rid,
                                reim_person_rid: arr[index].reim_person_rid,
                                fee_type_rid: arr[index].fee_type_rid,
                                corp_type: arr[index].corp_type
                            });
                        } else {
                            arr1.push({
                                amount: arr[index].amount,
                                tax_amount: 0,
                                invoice_amount: 0,
                                remark: arr[index].remark,
                                write_off_rid: arr[index].checkList[0].rid,
                                budget_item_rid: arr[index].budget_item_rid,
                                reim_person_rid: arr[index].reim_person_rid,
                                fee_type_rid: arr[index].fee_type_rid,
                                corp_type: arr[index].corp_type
                            });
                        }
                    }
                }
            }
            this.newExecutions = arr1;
        },
        //循环赋值每个 预算项目框
        budgetItemChange(item, index) {
            if (this.ruleForm.mk_report_type == '对公') {
                this.ruleForm.executions[index].budget_item_rid = item.budget_item_name;
                this.ruleForm.executions.forEach((value, index) => {
                    value.budget_item_rid = item.budget_item_name;
                    value.budget_item_name = item.budget_item_name;
                });
            } else {
                this.ruleForm.executions[index].budget_item_rid = item.budget_item_name;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
.search_class {
    font-size: 15px;
    cursor: pointer;
}
.history {
    margin-top: 10px;
    position: relative;
    max-height: 460px;
    overflow-y: scroll;
    .is-checked {
        background: rgb(240, 250, 255);
    }
    .history_list {
        margin: 0px 0 10px 0px;
        border: 1px solid rgb(238, 238, 238);
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        .header_title {
            display: block;
            width: 940px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            box-sizing: border-box;
            display: flex;
            padding: 0 20px 0 10px;
            justify-content: space-between;
            background: #f9f9f9;
            span:nth-child(2) {
                font-size: 14px;
            }
        }
        /deep/.el-checkbox__input {
            position: absolute;
            left: 10px;
            top: 18px;
        }
        /deep/.el-checkbox__label {
            padding: 0;
            color: #333;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 920px;
            height: 50px;
            box-sizing: border-box;
            padding: 0 0px 0 40px;
        }
        .item_content {
            width: 940px;
            .tag_text {
                width: 240px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .right_content {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                div {
                    display: flex;
                    justify-content: space-between;
                    width: 190px;
                    line-height: 25px;
                    font-size: 14px;
                    span {
                        display: inline-block;
                        width: 80px;
                        text-align: right;
                    }
                }
                .t_div {
                    span:nth-child(2) {
                        color: #409eff;
                    }
                }
                .b_div {
                    span:nth-child(2) {
                        color: #00b600;
                    }
                }
            }
        }
    }
}
.detail_from {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .el-form-item {
        width: 48%;
    }
    .reamrk_item {
        width: 96%;
    }
}
.checked_ {
    width: 840px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    .checked_list {
        width: 840px;
        border: 1px solid rgb(238, 238, 238);
        margin: 10px 0 10px 0px;
        padding: 10px 0;
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        position: relative;
        /deep/.el-form-item__content {
            margin: 0 !important;
            .el-form-item__error {
                width: 100px;
                position: absolute !important;
                top: 120px;
                left: 710px;
            }
        }
        .checked_title {
            display: block;
            width: 840px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            padding: 0 20px 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            background: #f9f9f9;
            span:nth-child(2) {
                font-size: 14px;
            }
        }
        .checked_content {
            width: 840px;
            box-sizing: border-box;
            padding: 1px 25px;
            display: flex;
            justify-content: space-between;
            .tag_text {
                min-width: 120px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .right_content {
                width: 300px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                div {
                    display: flex;
                    justify-content: space-between;
                    width: 240px;
                    line-height: 30px;
                    font-size: 14px;
                    span {
                        display: inline-block;
                        min-width: 100px;
                        text-align: right;
                    }
                }
                .t_div {
                    span:nth-child(2) {
                        color: #409eff;
                    }
                }
                .b_div {
                    span:nth-child(2) {
                        color: #00b600;
                    }
                }
                .amount_div {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    span {
                        /deep/.el-input {
                            width: 120px;
                            .el-input__inner {
                                width: 120px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>